import { AxiosError } from 'axios';
import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useEffect, useState } from 'react';
import { Spinner } from '../components/spinner';
import axios from '../config/axios';
import { User } from '../types/user.types';
interface ContextProps {
	user: User | null;
	setUser: Dispatch<SetStateAction<User | null>>;
	isAuthenticated: boolean;
	setIsAuthenticated: Dispatch<SetStateAction<boolean>>;
	role: 'admin' | 'retailer' | null;
	setRole: Dispatch<SetStateAction<'admin' | 'retailer' | null>>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const AuthContext = createContext<ContextProps>({
	user: null,
	setUser: () => null,
	isAuthenticated: false,
	setIsAuthenticated: () => false,
	role: null,
	setRole: () => null,
});

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
	const [user, setUser] = useState<User | null>(null);
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [role, setRole] = useState<'admin' | 'retailer' | null>(null);
	const maintenanceMode = false;

	useEffect(() => {
		(async () => {
			try {
				const { data } = await axios.get('/users/authenticate', { withCredentials: true });
				setIsAuthenticated(true);
				const admin: User = data.results;
				console.log(admin);
				let adminType =
					admin.staff_type === 'support_admin'
						? 'support_admin'
						: admin.staff_type === 'support'
							? 'support'
							: admin.staff_type === 'insurance'
								? 'insurance'
								: admin.is_superuser
									? 'super_admin'
									: 'admin';
				if (admin.role === 'retailer') {
					adminType = 'retailer';
				}
				admin.admin_type = adminType as 'super_admin' | 'support_admin' | 'support' | 'admin' | 'insurance' | 'retailer';
				setUser(admin);
				setRole(data.results.role);

				// if (data.results.role === 'retailer') {
				// 	window.location.href = '/retailer/dashboard';
				// } else {
				// 	window.location.href = '/admin/dashboard';
				// }
			} catch (error) {
				if (error instanceof AxiosError && error.response) {
					setIsAuthenticated(false);
					setUser(null);
				}
			} finally {
				setLoading(false);
			}
		})();
	}, []);

	return loading ? (
		<div className="flex h-dvh items-center justify-center dark:bg-dark-bg">
			<Spinner />
		</div>
	) : maintenanceMode ? (
		<div className="flex h-dvh items-center justify-center dark:bg-dark-bg">
			<div className="flex flex-col items-center justify-center gap-4 px-4">
				<img
					src="/images/misc/maintenance_mode.png"
					alt="maintenance_mode"
					className="size-20 dark:invert"
				/>

				<h1 className="text-center text-2xl font-bold md:text-4xl dark:text-white">System Upgrade in Progress.</h1>

				<h2 className="text-center text-base font-medium md:text-xl dark:text-white">
					Our team of engineers is currently conducting scheduled maintenance.
				</h2>
			</div>
		</div>
	) : (
		<AuthContext.Provider
			value={{
				user,
				setUser,
				isAuthenticated,
				setIsAuthenticated,
				role,
				setRole,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
